import { faFile } from '@fortawesome/pro-light-svg-icons'

import { TopBar } from '@domain-group/suit-theme'

import useDashboardSearch from './hooks/useDashboardSearch'
import SearchResult from './components/SearchResult'

interface DashboardSearchProps {
  searchEntities: Array<any>,
}

const DashboardSearch = (props:DashboardSearchProps) => {
  const { searchEntities } = props

  const {
    callbacks: {
      dashboardSearch,
      mapResults,
    },
  } = useDashboardSearch({ searchEntities })

  return (
    <TopBar.Search
      callbacks={{ search: dashboardSearch }}
      mapResults={data => mapResults(data)}
      renderResult={entity => <SearchResult key={entity.id} icon={faFile} result={entity} />}
    />
  )
}

export default DashboardSearch
